import { Badge } from '@/components/ui';
import { useI18n } from '@/i18n';
import type { User } from '@/lib/api';
import { useLabel } from '@/lib/useLabel';

import { awaitingSignIn } from './signIn';

/**
 * One answer to "what state is this account in", for the list and the employee page
 * alike. Suspended and archived come from the database; whether the invitation has been
 * accepted comes from Cognito when it answered — someone who has signed in is active,
 * whatever the database last wrote.
 */
export function AccountStatusBadge({ user }: { user: User }) {
  const { t } = useI18n();
  const L = useLabel();

  if (user.status === 'suspended' || user.status === 'archived') {
    const s = L('user', user.status);
    return <Badge tone={s.tone}>{s.label}</Badge>;
  }
  if (awaitingSignIn(user)) {
    return <Badge tone="warning">{t(user.signIn === 'none' ? 'access.noSignIn' : 'access.invited')}</Badge>;
  }
  const active = L('user', 'active');
  return <Badge tone={active.tone}>{active.label}</Badge>;
}
